module.exports = __webpack_public_path__ + "img/banner.65043d20.jpg";